// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3207d816","977":"33a0bfd9"}[chunkId] + ".chunk.js";
};